/* src/app/private/components/leads/bulk-update/bulk-update.component.scss */
/*# sourceMappingURL=bulk-update.component.css.map */
